import { Box } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "./Button";

interface Props {
  onBack?: () => void;
  onNext: () => void;
  backLabel?: string;
  nextLabel?: string;
  nextDisabled?: boolean;
  /** data-testid del botón "Regresar", para pruebas automatizadas. */
  backTestId?: string;
  /** data-testid del botón "Continuar", para pruebas automatizadas. */
  nextTestId?: string;
}

export const StepActions = ({
  onBack,
  onNext,
  backLabel = "Regresar",
  nextLabel = "Continuar",
  nextDisabled,
  backTestId,
  nextTestId,
}: Props) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4, gap: 2 }}>
    {onBack ? (
      <Button tone="ghost" startIcon={<ChevronLeft fontSize="small" />} onClick={onBack} data-testid={backTestId}>
        {backLabel}
      </Button>
    ) : (
      <Box />
    )}
    <Button tone="primary" onClick={onNext} disabled={nextDisabled} withArrow data-testid={nextTestId}>
      {nextLabel}
    </Button>
  </Box>
);
